import { useCallback } from 'react';

import { useSmartLinkActions } from '@atlaskit/smart-card/hooks';

// This hook returns the actions for a given URL
export const useOpenPreviewModal = (url: string) => {
	const actions = useSmartLinkActions({
		url,
		appearance: 'inline',
		prefetch: true,
	});

	const openModal = useCallback(() => {
		const previewAction = actions.find((action) => action.id === 'preview-content');
		if (previewAction) {
			previewAction.invoke();
		}
	}, [actions]);

	return { openModal, actions };
};
